import React from "react";
interface props {
  children: React.ReactNode;
}
const SignupLayout: React.FC<props> = ({ children }) => {
  return (
    <div className="container  ">
      <div className="border min-w-fit w-[100%] 2xl:w-[80%] px-7  py-[120px]  mt-20 mb-[120px] shadow-container  ">
        {children}
      </div>
    </div>
  );
};

export default SignupLayout;
